import { useQuery } from 'react-query';
import { useQueryClient } from 'react-query';

import { getPdpRecommendSize } from '../graphql/pdp-recommend-size.2';
import { GetPdpRecommendSize_pdp_recommend_group_PDPRecommendGroup } from '../graphql/pdp-recommend-size_types.2';
import {
  GetPdpRecommendGroup_related_item_list_PDPRecommendGroup,
  PDPGoodsGroup,
} from '../graphql/related-product-recommend-group_types.2';
import { useCatalogProductIdParams } from '../hooks/useCatalogProductIdParams';
import { queryOptions } from '../lib/queryHelpers';
import { PDP_RELATED_PRODUCT_RECOMMEND_GROUP_QUERY_KEY } from '../repositories/related-product-recommend-group';

const QUERY_KEY = 'PDP_RECOMMEND_SIZE';

interface PdprecommendSizeParams {
  catalog_product_id: string;
}

function getCachedBottomArea(cachedData: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup[]) {
  try {
    const bottomArea = cachedData ? (cachedData[0]?.bottom_area as PDPGoodsGroup[]) : [];

    return Boolean(bottomArea[0]?.goods_carousel.component_list.length);
  } catch {
    return false;
  }
}

export function PdpRecommendSizeQueryOption(params: PdprecommendSizeParams, enabled: boolean) {
  return {
    queryKey: [QUERY_KEY],
    queryFn: async function () {
      const { data } = await getPdpRecommendSize({
        catalog_product_id: params.catalog_product_id,
      });
      return data?.pdp_recommend_group[0] as GetPdpRecommendSize_pdp_recommend_group_PDPRecommendGroup;
    },
    ...queryOptions,
    enabled,
  };
}

export const usePdpRecommendSize = () => {
  const queryClient = useQueryClient();
  const cachedData = queryClient.getQueryData<GetPdpRecommendGroup_related_item_list_PDPRecommendGroup[]>([
    PDP_RELATED_PRODUCT_RECOMMEND_GROUP_QUERY_KEY,
  ]);

  const params = useCatalogProductIdParams();
  const response = useQuery(PdpRecommendSizeQueryOption(params, !cachedData));
  const has_recommend_size = cachedData ? getCachedBottomArea(cachedData) : Boolean(response.data?.bottom_area_size);

  return {
    ...response,
    has_recommend_size,
  };
};
